import React, { useMemo } from "react"
import { Data } from "../service/global";
import { MDBIcon } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";

export interface StatusIconProps {
    name: string;
    ts: number|Date;
    count?: number;
    badge?: boolean;
    onClick?: () => void;

}

export const StatusIcon = ({badge, name, ts, count, onClick}: StatusIconProps) => {
    const { t } = useTranslation();

    const  { icon, level } = useMemo(() => {
        const es = Data.esList[name];
        return {
            icon: es?.web?.icon || "circle-question",
            level: es?.web?.level || "danger"
        }
    }, [name]);
    
    const title = useMemo(() => 
        !badge
        ? t(`status:${name}`)
        : `At: ${(new Date(ts)).toLocaleString()}`, [ts, badge, name, t]);

    if (badge) return (
        <React.Fragment>
            <span
                role={onClick ? "button" : undefined}
                className={`badge badge-${level} ms-1`}
                style={{cursor: 'pointer', height: 20}}
                title={title}
                onClick={onClick}
            >
                {(count && count > 1) &&
                    <span className="me-1">{count}</span>
                }
                <span><MDBIcon icon={icon} color={level} className="me-1"/></span>
                <span>{t(`status:${name}`)}</span>
            </span>
        </React.Fragment>
    )

    return (
        <React.Fragment>
            <span
                className={"position-relative " + ((count && count > 1) ? 'me-1' : 'me-0')}
                title={title}
            >
                <span><MDBIcon icon={icon} color={level} fixed/></span>
                {(count && count > 1) && 
                    <span
                        className={`position-absolute bg-${level} d-flex justify-content-center align-items-center text-white`}
                        style={{right: '-15%', top: 12, lineHeight: 1, borderRadius: 14, height: 14, width: 14, padding: 3, fontSize: '0.6em'}}
                    >
                        <span>{count}</span>
                    </span> 
                }
            </span>
        </React.Fragment>
    )
}